<template>
  <v-container :fluid="true">
    <v-card
      v-if="isWordListReady && !displayConfirmDialog && !displayCompletedDialog"
      :flat="true"
    >
      <Form v-slot="{ meta, validate }" ref="formRef" :validate-on-mount="validateOnMount">
        <v-card :flat="true">
          <v-card-title
            v-if="!listEditFlag"
            class="mb-3 text-h5 font-weight-bold"
          >
            {{ wordList["lbl_shop_regist"] }}
          </v-card-title>
          <v-card-title v-else class="mb-3 text-h5 font-weight-bold">
            店舗編集
          </v-card-title>
          <v-card-text>
            <v-card :flat="true" class="pl-5 pt-3">
              <!-- チェーンコード -->
              <v-row v-if="chainViewFlag">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_chain_name }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col v-if="!updateMode" cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_chain_name"
                    rules="required"
                    v-model="chainSelectValues"
                  >
                    <v-autocomplete
                      v-model="chainSelectValues"
                      density="compact"
                      :items="chainListItems"
                      item-title="name"
                      item-value="chain_code"
                      :placeholder="wordList.plc_selectbox"
                      :no-data-text="wordList.lbl_no_data_text"
                      bg-color="white"
                      return-object
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          Object.assign(
                            chainSelectValues,
                            val || { chain_code: '', name: '' },
                          );
                          onChangeChain(val);
                        }
                      "
                      @blur="field.onBlur"
                    ></v-autocomplete>
                  </Field>
                </v-col>
                <v-col v-if="updateMode" cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_chain_name"
                    rules="required"
                    v-model="chainSelectValues"
                  >
                    <v-autocomplete
                      v-model="chainSelectValues"
                      density="compact"
                      :items="chainListItems"
                      item-title="name"
                      item-value="chain_code"
                      :placeholder="wordList.plc_selectbox"
                      :no-data-text="wordList.lbl_no_data_text"
                      bg-color="white"
                      return-object
                      variant="outlined"
                      :disabled="true"
                      :error-messages="errors"
                      @blur="field.onBlur"
                    ></v-autocomplete>
                  </Field>
                </v-col>
              </v-row>
              <!-- 店舗コード -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_shop_code }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col v-if="!updateMode || !listEditFlag" cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_shop_code"
                    rules="required|max:8|regex:^[0-9a-zA-Z-_]+$"
                    :model-value="shopCreateInput.shop_code"
                  >
                    <v-text-field
                      :model-value="field.value ?? shopCreateInput.shop_code"
                      density="compact"
                      :placeholder="wordList.plc_shop_code"
                      variant="outlined"
                      :disabled="
                        !chainSelectValues ||
                        chainSelectValues.chain_code === ''
                      "
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          shopCreateInput.shop_code = val;
                          onInputShopCd();
                        }
                      "
                      @blur="
                        () => {
                          field.onBlur();
                          onBlurShopCd();
                        }
                      "
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col v-if="updateMode && listEditFlag" cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_shop_code"
                    rules="required|max:8|regex:^[0-9a-zA-Z-_]+$"
                    :model-value="shopCreateInput.shop_code"
                  >
                    <v-text-field
                      :model-value="field.value ?? shopCreateInput.shop_code"
                      density="compact"
                      :placeholder="wordList.plc_shop_code"
                      variant="outlined"
                      :error-messages="errors"
                      :disabled="true"
                      class="border-none"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          shopCreateInput.shop_code = val;
                          onInputShopCd();
                        }
                      "
                      @blur="
                        () => {
                          field.onBlur();
                          onBlurShopCd();
                        }
                      "
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 店舗名 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_shop_name }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_shop_name"
                    rules="required|max:20"
                    v-model="shopCreateInput.name"
                  >
                    <v-text-field
                      v-model="shopCreateInput.name"
                      density="compact"
                      :placeholder="wordList.plc_shop_name"
                      variant="outlined"
                      :error-messages="errors"
                      @blur="
                        () => {
                          field.onBlur();
                          onBlurShopName();
                        }
                      "
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 店舗名かな -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_shop_name_kana }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_shop_name_kana"
                    rules="required|max:20|regex:^[ぁ-んー]+$"
                    v-model="shopCreateInput.name_kana"
                    >
                    <v-text-field
                      :model-value="field.value ?? shopCreateInput.name_kana"
                      density="compact"
                      :placeholder="wordList.plc_shop_name_kana"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          shopCreateInput.name_kana = val;
                        }
                      "
                      @blur="
                        () => {
                          field.onBlur();
                          onBlurShopName();
                        }
                      "
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 接続先のDSS -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_dss_connection_id }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                  v-if="
                    chainSelectValues && chainSelectValues.chain_code !== ''
                  "
                  cols="4"
                >
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_dss_connection_id"
                    rules="required"
                    v-model="dssSelectValues"
                  >
                    <v-autocomplete
                      v-model="dssSelectValues"
                      density="compact"
                      :items="dssListItems"
                      item-title="connection_name"
                      item-value="connection_id"
                      :placeholder="wordList.plc_selectbox"
                      :no-data-text="wordList.lbl_no_data_text"
                      bg-color="white"
                      return-object
                      variant="outlined"
                      :error-messages="errors"
                      :disabled="
                        !chainSelectValues ||
                        chainSelectValues.chain_code === ''
                      "
                      @update:model-value="
                        onChangeDssConnectionId(
                          dssSelectValues.connection_id,
                          true,
                        )
                      "
                      @blur="field.onBlur"
                    ></v-autocomplete>
                  </Field>
                </v-col>
              </v-row>
              <!-- DSS店舗コード -->
              <v-row v-if="dssFlg">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense v-if="dssFlg" justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_dss_shop_code }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                  <v-row align="center" dense v-if="!dssFlg" justify="end" class="form-label-row mr-15">
                    {{ wordList.lbl_dss_shop_code }}
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_dss_shop_code"
                    rules="required|max:10"
                    v-model="shopCreateInput.dss_shop_code"
                  >
                    <v-text-field
                      v-model="shopCreateInput.dss_shop_code"
                      density="compact"
                      :placeholder="wordList.plc_dss_shop_code"
                      variant="outlined"
                      :error-messages="errors"
                      @blur="
                        () => {
                          field.onBlur();
                          onBlurDssShopCd();
                        }
                      "
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- DSS店舗名（表示専用項目のため、vee-validateのFieldから除外） -->
              <v-row v-if="dssFlg" class="mb-5">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-15">
                    {{ wordList.lbl_dss_shop_name }}
                  </v-row>
                </v-col>
                <v-col cols="6" class="py-2 color_black">
                  <v-card-text class="py-0 px-0">
                    {{ dss_shop_name }}
                  </v-card-text>
                </v-col>
              </v-row>
              <!-- 休日設定 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-15">
                    {{ wordList.lbl_holiday_setting }}
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="holidaySelectValues"
                    density="compact"
                    :items="holidayItems"
                    item-title="label"
                    item-value="value"
                    :placeholder="wordList.plc_selectbox"
                    :no-data-text="wordList.lbl_no_data_text"
                    multiple
                    variant="outlined"
                    return-object
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <!-- 郵便番号 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_zipcode }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <Field
                    v-slot="{ field, errors }"
                    name="zip_code"
                    :label="wordList['lbl_zipcode']"
                    rules="required|numeric|length:7"
                    v-model="shopCreateInput.zip_code"
                  >
                    <v-text-field
                      :model-value="field.value ?? shopCreateInput.zip_code"
                      density="compact"
                      :placeholder="wordList.plc_zipcode"
                      variant="outlined"
                      :hint="wordList.lbl_no_hyphen"
                      persistent-hint
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          shopCreateInput.zip_code = val;
                          onZipCodeInput();
                        }
                      "
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <v-row v-if="errorZipCode">
                <v-col cols="3"> </v-col>
                <v-col cols="6">
                  <v-card-text class="text-red px-0 py-0">
                    {{ errorZipCode }}
                  </v-card-text>
                </v-col>
              </v-row>
              <!-- 住所（表示専用項目のため、vee-validateのFieldから除外） -->
              <v-row class="mb-5">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-15">
                    {{ wordList.lbl_address }}
                  </v-row>
                </v-col>
                <v-col cols="6" class="py-2 color_black">
                  <v-card-text class="py-0 px-0">
                    {{ shopCreateInput.address1 }}
                  </v-card-text>
                </v-col>
              </v-row>
              <!-- 丁目 -->
              <v-row v-if="blockList.length > 0">
                <v-col cols="3"></v-col>
                <v-col cols="6">
                  <v-card
                    v-if="shopCreateInput.address1"
                    variant="outlined"
                    class="pt-2 pb-2"
                    style="border-width: 2px"
                  >
                    <span
                      v-for="(value, key) in blockList"
                      :key="key"
                      class="mx-3 text-blue text-decoration-underline"
                      style="cursor: pointer"
                      @click="onClickAddressBlockLink(value)"
                    >
                      {{ value || "その他" }}
                    </span>
                  </v-card>
                  <v-card-text
                    v-if="errorMessage !== null && errorMessage !== undefined"
                    class="text-red"
                  >
                    {{ errorMessage }}
                  </v-card-text>
                </v-col>
              </v-row>
              <!-- 番地 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_address_detail }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_address_detail"
                    rules="required|max:50"
                    v-model="shopCreateInput.address2"
                  >
                    <v-text-field
                      v-model="shopCreateInput.address2"
                      density="compact"
                      :placeholder="wordList.plc_address_detail"
                      variant="outlined"
                      :error-messages="errors"
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 建物名 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-15">
                    {{ wordList.lbl_room_num }}
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <Field
                    v-slot="{ errors }"
                    :name="wordList.lbl_room_num"
                    rules="max:50"
                    v-model="shopCreateInput.address3"
                  >
                    <v-text-field
                      v-model="shopCreateInput.address3"
                      density="compact"
                      :placeholder="wordList.plc_room_num"
                      variant="outlined"
                      :error-messages="errors"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 電話番号 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_tel }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_tel"
                    rules="required|numeric|max:11"
                    v-model="shopCreateInput.phone"
                  >
                    <v-text-field
                      v-model="shopCreateInput.phone"
                      density="compact"
                      :placeholder="wordList.plc_tel"
                      variant="outlined"
                      :hint="wordList.lbl_no_hyphen"
                      persistent-hint
                      :error-messages="errors"
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- FAX -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-15">
                    {{ wordList.lbl_fax }}
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <Field
                    v-slot="{ errors }"
                    :name="wordList.lbl_fax"
                    rules="numeric|max:11"
                    v-model="shopCreateInput.fax"
                  >
                    <v-text-field
                      v-model="shopCreateInput.fax"
                      density="compact"
                      :placeholder="wordList.plc_fax"
                      variant="outlined"
                      :hint="wordList.lbl_no_hyphen"
                      persistent-hint
                      :error-messages="errors"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 残配達可能数の表示方法 -->
              <v-row class="mb-5">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_cur_deliverable_display_method }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_cur_deliverable_display_method"
                    rules="required"
                    v-model="deliverableSelectValues"
                  >
                    <v-radio-group
                      v-model="deliverableSelectValues"
                      inline
                      mandatory
                      class="mt-0"
                      :error-messages="errors"
                      @blur="field.onBlur"
                      @update:model-value="
                        (val) => {
                          onChangeDeliverable(val.index);
                        }
                      "
                    >
                      <v-radio
                        v-for="item in deliverableItems"
                        :key="item.index"
                        :label="item.item"
                        :value="item"
                        color="indigo"
                        density="compact"
                      ></v-radio>
                    </v-radio-group>
                  </Field>
                </v-col>
              </v-row>
              <!-- △表示の閾値の上限 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense
                    v-if="deliverableSelectValues.index === '0'"
                    justify="end"
                      class="form-label-row mr-15"
                  >
                    {{ wordList.lbl_alert_upper_threshold }}
                  </v-row>
                  <v-row align="center" dense
                    v-if="deliverableSelectValues.index === '1'"
                    justify="end"
                      class="form-label-row mr-3"
                  >
                    {{ wordList.lbl_alert_upper_threshold }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <Field
                    v-if="deliverableSelectValues.index === '0'"
                    v-slot="{ errors }"
                    :name="wordList.lbl_alert_upper_threshold"
                    rules="numeric|max:2"
                    v-model="shopCreateInput.alert_upper_threshold"
                  >
                    <v-text-field
                      v-model="shopCreateInput.alert_upper_threshold"
                      density="compact"
                      variant="outlined"
                      persistent-hint
                      :disabled="isDeliverableNumberDisplay"
                      :error-messages="errors"
                    ></v-text-field>
                  </Field>
                  <Field
                    v-if="deliverableSelectValues.index === '1'"
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_alert_upper_threshold"
                    rules="required|numeric|max:2"
                    v-model="shopCreateInput.alert_upper_threshold"
                  >
                    <v-text-field
                      v-model="shopCreateInput.alert_upper_threshold"
                      density="compact"
                      variant="outlined"
                      persistent-hint
                      :disabled="isDeliverableNumberDisplay"
                      :error-messages="errors"
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 荷札印刷 -->
              <v-row class="mb-5">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_shipping_label_print_flg }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_shipping_label_print_flg"
                    rules="required"
                    v-model="shippingLabelPrintSelectValues"
                  >
                    <v-radio-group
                      v-model="shippingLabelPrintSelectValues"
                      inline
                      mandatory
                      class="mt-0"
                      :error-messages="errors"
                      @blur="field.onBlur"
                    >
                      <v-radio
                        v-for="item in shippingLabelPrintItems"
                        :key="item.index"
                        :label="item.item"
                        :value="item"
                        color="indigo"
                        density="compact"
                      ></v-radio>
                    </v-radio-group>
                  </Field>
                </v-col>
              </v-row>
              <!-- 配達伝票印刷 -->
              <v-row class="mb-5">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_delivery_order_print_flg }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_delivery_order_print_flg"
                    rules="required"
                    v-model="deliveryOrderPrintSelectValues"
                  >
                    <v-radio-group
                      v-model="deliveryOrderPrintSelectValues"
                      inline
                      mandatory
                      class="mt-0"
                      :error-messages="errors"
                      @blur="field.onBlur"
                    >
                      <v-radio
                        v-for="item in deliveryOrderPrintItems"
                        :key="item.index"
                        :label="item.item"
                        :value="item"
                        color="indigo"
                        density="compact"
                      ></v-radio>
                    </v-radio-group>
                  </Field>
                </v-col>
              </v-row>
              <!-- 配送依頼受付通知先メールアドレス -->
              <v-row v-if="deliveryOrderPrintSelectValues.index">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-3">
                    {{ wordList.lbl_delivery_request_notification_emails }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_delivery_request_notification_emails"
                    :rules="{
                      required: true,
                      max: 500,
                      multipleEmail: true,
                    }"
                    v-model="
                      shopCreateInput.delivery_request_notification_emails
                    "
                  >
                    <v-text-field
                      v-model="
                        shopCreateInput.delivery_request_notification_emails
                      "
                      density="compact"
                      :placeholder="
                        wordList.plc_delivery_request_notification_emails
                      "
                      variant="outlined"
                      :hint="wordList.lbl_devide_comma"
                      persistent-hint
                      :error-messages="errors"
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 2件分配達個口数 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-10">
                    {{ wordList.lbl_double_deli_oricon_count }}
                    <v-tooltip location="top">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" icon="mdi-help-circle-outline" />
                      </template>
                      <!-- eslint-disable-next-line vue/no-v-html -->
                      <span
                        v-html="
                          doubleDeliOriconCountHintMessage ||
                          wordList.lbl_double_deli_oricon_count_hint
                        "
                      ></span>
                    </v-tooltip>
                  </v-row>
                </v-col>
                <v-col cols="5">
                  <Field
                    v-slot="{ errors }"
                    :name="wordList.lbl_double_deli_oricon_count"
                    :rules="{
                      integer: true,
                      max_value: 999,
                      lessThanCharter: {
                        charter_deli_oricon_count:
                          shopCreateInput.charter_deli_oricon_count,
                        double_deli_oricon_count_label:
                          wordList.lbl_double_deli_oricon_count,
                        charter_deli_oricon_count_label:
                          wordList.lbl_charter_deli_oricon_count,
                      },
                    }"
                    v-model="shopCreateInput.double_deli_oricon_count"
                  >
                    <v-text-field
                      v-model="shopCreateInput.double_deli_oricon_count"
                      density="compact"
                      variant="outlined"
                      persistent-hint
                      :error-messages="errors"
                      :hint="wordList.lbl_double_deli_oricon_count_hint"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- チャーター便個口数 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense justify="end" class="form-label-row mr-10">
                    {{ wordList.lbl_charter_deli_oricon_count }}
                    <v-tooltip location="top">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" icon="mdi-help-circle-outline" />
                      </template>
                      <!-- eslint-disable-next-line vue/no-v-html -->
                      <span
                        v-html="
                          charterDeliOriconCountHintMessage ||
                          wordList.lbl_charter_deli_oricon_count_hint
                        "
                      ></span>
                    </v-tooltip>
                  </v-row>
                </v-col>
                <v-col cols="5">
                  <Field
                    v-slot="{ errors }"
                    :name="wordList.lbl_charter_deli_oricon_count"
                    rules="numeric|max_value:999"
                    v-model="shopCreateInput.charter_deli_oricon_count"
                  >
                    <v-text-field
                      v-model="shopCreateInput.charter_deli_oricon_count"
                      density="compact"
                      variant="outlined"
                      persistent-hint
                      :error-messages="errors"
                      :hint="wordList.lbl_charter_deli_oricon_count_hint"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 仮会員登録機能 -->
              <v-row class="mb-5">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_temp_member_registration_flg }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_temp_member_registration_flg"
                    rules="required"
                    v-model="tmpMemberRegistrationSelectValues"
                  >
                    <v-radio-group
                      v-model="tmpMemberRegistrationSelectValues"
                      inline
                      mandatory
                      class="mt-0"
                      :error-messages="errors"
                      @blur="field.onBlur"
                    >
                      <v-radio
                        v-for="item in tmpMemberRegistrationItems"
                        :key="item.index"
                        :label="item.item"
                        :value="item"
                        color="indigo"
                        density="compact"
                      ></v-radio>
                    </v-radio-group>
                  </Field>
                </v-col>
              </v-row>
              <!--
                運営管理者:
                  - 店舗登録: ○
                  - 店舗編集: ○
                  - ポイントサーバー設定: ×

                本部権限:
                  - 店舗登録: ×
                  - 店舗編集: ○
                  - ポイントサーバー設定: ○（店舗編集時のみ）
              -->
              <!-- ポイントサーバーストアコード -->
              <v-row v-if="useReceiptBarcodeSearch && listEditFlag">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_point_server_store_code }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_point_server_store_code"
                    rules="required|max:4|numeric"
                    v-model="shopCreateInput.point_server_store_code"
                  >
                    <v-text-field
                      v-model="shopCreateInput.point_server_store_code"
                      :placeholder="wordList.plc_point_server_store_code"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          shopCreateInput.point_server_store_code = val;
                        }
                      "
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- ポイントサーバーIPアドレス -->
              <v-row v-if="useReceiptBarcodeSearch && listEditFlag">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_point_server_ip_address }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_point_server_ip_address"
                    rules="required|ip_address"
                    v-model="shopCreateInput.point_server_ip_address"
                  >
                    <v-text-field
                      v-model="shopCreateInput.point_server_ip_address"
                      :placeholder="wordList.plc_point_server_ip_address"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          const trimmed = val ? val.trim() : val;
                          field.onChange(trimmed);
                          shopCreateInput.point_server_ip_address = trimmed;
                        }
                      "
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- ポイントサーバーDB名 -->
              <v-row v-if="useReceiptBarcodeSearch && listEditFlag">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_point_server_db_name }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_point_server_db_name"
                    rules="required|db_schema"
                    v-model="shopCreateInput.point_server_db_name"
                  >
                    <v-text-field
                      v-model="shopCreateInput.point_server_db_name"
                      :placeholder="wordList.plc_point_server_db_name"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          const trimmed = val ? val.trim() : val;
                          field.onChange(trimmed);
                          shopCreateInput.point_server_db_name = trimmed;
                        }
                      "
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
          <v-card-actions class="justify-center py-10">
            <!-- 店舗一覧へ戻る -->
            <v-btn
              v-if="updateMode"
              variant="flat"
              color="return"
              class="px-16"
              @click="onClickBack"
            >
              <v-icon>mdi-arrow-left</v-icon>
              {{ wordList.btn_return }}</v-btn
            >
            <v-btn
              variant="flat"
              color="primary"
              class="px-16"
              :disabled="!meta.valid"
              @click="() => onClickOpenConfirmDialog(validate)"
            >
              <v-icon>mdi-playlist-edit</v-icon>
              <span v-if="!listEditFlag">{{
                wordList.btn_regist_confirm
              }}</span>
              <span v-else>変更手続きへ(確認)</span>
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-overlay
          :model-value="overlay"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </Form>
    </v-card>
    <!-- 店舗登録確認ダイアログ { -->
    <v-card v-if="isWordListReady && displayConfirmDialog" :flat="true">
      <v-card :flat="true">
        <v-card-title
          v-if="!listEditFlag"
          class="mb-3 text-h5 font-weight-bold"
        >
          {{ wordList.lbl_shop_regist_confirm }}
        </v-card-title>
        <v-card-title v-else class="mb-3 text-h5 font-weight-bold">
          店舗編集確認
        </v-card-title>
        <v-card-text style="min-height: 500px" class="pt-5 confirm-display-text">
          <!-- チェーンコード -->
          <v-row v-if="chainViewFlag" class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_chain_name }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ chainSelectValues.name }}</v-col>
          </v-row>
          <!-- 店舗コード -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_shop_code }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.shop_code }}</v-col>
          </v-row>
          <v-row class="mb-3">
            <!-- 店舗名 -->
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_shop_name }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.name }}</v-col>
          </v-row>
          <v-row class="mb-3">
            <!-- 店舗名かな -->
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_shop_name_kana }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.name_kana }}</v-col>
          </v-row>
          <!-- 接続先のDSS -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_dss_connection_id }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ dssSelectValues.connection_name }}</v-col>
          </v-row>
          <!-- DSS店舗コード -->
          <v-row v-if="dssFlg" class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_dss_shop_code }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.dss_shop_code }}</v-col>
          </v-row>
          <!-- DSS店舗名 -->
          <v-row v-if="dssFlg" class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="form-label-row pl-2 mr-12" justify="end">
                {{ wordList.lbl_dss_shop_name }}
              </v-row>
            </v-col>
            <v-col cols="9">{{ dss_shop_name }}</v-col>
          </v-row>
          <v-row class="mb-3">
            <!-- 休日設定 -->
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="form-label-row pl-2 mr-12" justify="end">
                {{ wordList.lbl_holiday_setting }}
              </v-row>
            </v-col>
            <v-col cols="9">
              <span v-for="item in holidaySelectValues" :key="item.label">
                {{ item.label }}
              </span>
            </v-col>
          </v-row>
          <v-row class="mb-3">
            <!-- 郵便番号 -->
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_zipcode }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.zip_code }}</v-col>
          </v-row>
          <v-row class="mb-3">
            <!-- 住所 -->
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="form-label-row pl-2 mr-12" justify="end">
                {{ wordList.lbl_address }}
              </v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.address1 }}</v-col>
          </v-row>
          <v-row class="mb-3">
            <!-- 番地 -->
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_address_detail }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.address2 }}</v-col>
          </v-row>
          <v-row class="mb-3">
            <!-- 建物名 -->
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="form-label-row pl-2 mr-12" justify="end">{{
                wordList.lbl_room_num
              }}</v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.address3 }}</v-col>
          </v-row>
          <v-row class="mb-3">
            <!-- 電話番号 -->
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end"
                >{{ wordList.lbl_tel }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.phone }}</v-col>
          </v-row>
          <!-- FAX -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="form-label-row pl-2 mr-12" justify="end">{{
                wordList.lbl_fax
              }}</v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.fax }}</v-col>
          </v-row>
          <!-- 残配達可能数の表示方法 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end"
                >{{ wordList.lbl_cur_deliverable_display_method }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ deliverableSelectValues.item }}</v-col>
          </v-row>
          <!-- △表示の閾値の上限 -->
          <v-row v-if="!isDeliverableNumberDisplay" class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_alert_upper_threshold }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.alert_upper_threshold }}</v-col>
          </v-row>
          <!-- 荷札印刷 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end"
                >{{ wordList.lbl_shipping_label_print_flg }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ shippingLabelPrintSelectValues.item }}</v-col>
          </v-row>
          <!-- 配達伝票印刷 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end"
                >{{ wordList.lbl_delivery_order_print_flg }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ deliveryOrderPrintSelectValues.item }}</v-col>
          </v-row>
          <!-- 配送依頼受付通知先メールアドレス -->
          <v-row v-if="deliveryOrderPrintSelectValues.index" class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end"
                >{{ wordList.lbl_delivery_request_notification_emails }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{
              shopCreateInput.delivery_request_notification_emails
            }}</v-col>
          </v-row>
          <!-- 2件分配達個口 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_double_deli_oricon_count }}
              </v-row>
            </v-col>
            <v-col cols="9">
              {{
                shopCreateInput.double_deli_oricon_count === "" ||
                shopCreateInput.double_deli_oricon_count === 0
                  ? "-"
                  : shopCreateInput.double_deli_oricon_count
              }}
            </v-col>
          </v-row>
          <!-- チャーター便個口 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_charter_deli_oricon_count }}
              </v-row>
            </v-col>
            <v-col cols="9">
              {{
                shopCreateInput.charter_deli_oricon_count === "" ||
                shopCreateInput.charter_deli_oricon_count === 0
                  ? "-"
                  : shopCreateInput.charter_deli_oricon_count
              }}
            </v-col>
          </v-row>
          <!-- 仮会員登録機能 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end"
                >{{ wordList.lbl_temp_member_registration_flg }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ tmpMemberRegistrationSelectValues.item }}</v-col>
          </v-row>
          <!--
            運営管理者:
              - 店舗登録: ○
              - 店舗編集: ○
              - ポイントサーバー設定: ×

            本部権限:
              - 店舗登録: ×
              - 店舗編集: ○
              - ポイントサーバー設定: ○（店舗編集時のみ）
          -->
          <!-- ポイントサーバーストアコード -->
          <v-row class="mb-3" v-if="useReceiptBarcodeSearch && listEditFlag">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_point_server_store_code }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{
              shopCreateInput.point_server_store_code
            }}</v-col>
          </v-row>
          <!-- ポイントサーバーIPアドレス -->
          <v-row class="mb-3" v-if="useReceiptBarcodeSearch && listEditFlag">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_point_server_ip_address }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{
              shopCreateInput.point_server_ip_address
            }}</v-col>
          </v-row>
          <!-- ポイントサーバーDB名 -->
          <v-row class="mb-3" v-if="useReceiptBarcodeSearch && listEditFlag">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_point_server_db_name }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ shopCreateInput.point_server_db_name }}</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            variant="flat"
            color="return"
            class="px-16"
            @click="onClickConfirmCancel"
          >
            <v-icon>mdi-arrow-left</v-icon>
            {{ wordList.btn_return }}</v-btn
          >
          <v-btn
            variant="flat"
            color="primary"
            class="px-16"
            @click="onClickConfirmEntry"
          >
            <v-icon>mdi-playlist-edit</v-icon>
            <span v-if="!listEditFlag">{{ wordList.btn_regist_complete }}</span>
            <span v-else>変更手続きへ(完了)</span></v-btn
          >
        </v-card-actions>
        <v-overlay
          :model-value="overlay"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-card>
    <!-- } 店舗登録確認ダイアログ -->
    <!-- 店舗登録完了ダイアログ { -->
    <v-card v-if="isWordListReady && displayCompletedDialog" :flat="true">
      <v-card
        v-if="createShopMutation !== null && createShopMutation !== undefined"
        flat
      >
        <v-card-title class="mb-3 text-h5 font-weight-bold">
          {{ wordList.lbl_shop_regist_complete }}
        </v-card-title>
        <v-card-text style="min-height: 500px">
          <v-row class="pt-5">
            <v-col class="font-weight-black">
              {{ wordList.lbl_shop_regist_complete_msg }}
            </v-col>
          </v-row>
          <v-row class="ml-5">
            <!-- 店舗コード -->
            <v-col cols="3" class="font-weight-black">
              {{ wordList.lbl_shop_code }}
            </v-col>
            <v-col cols="9">{{
              createShopMutation.createShop.ShopResponse.shop_code
            }}</v-col>
          </v-row>
          <v-row class="ml-5">
            <v-col cols="3" class="font-weight-black">
              {{ wordList.lbl_shop_name }}
            </v-col>
            <v-col cols="9">
              {{ createShopMutation.createShop.ShopResponse.name }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            variant="flat"
            class="px-16"
            @click="onClickCompletedGoStart"
          >
            {{ wordList.btn_shop_regist_return }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-card>
    <!-- } 店舗登録完了ダイアログ -->
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
    <!-- 行政区画ダイアログ -->
    <AreaSelectorDialog
      :area-dialog="areaDialog"
      :title="wordList.lbl_address"
      :selected-address="selectedAddressLabel"
      :city-block-list="cityBlockList"
      :section-block-list="sectionBlockList"
      :block-list="areaDialogBlockList"
      :click-disabled="false"
      :word-list="wordList"
      @update:area-dialog="onAreaDialogUpdate"
      @select-city="onClickCityBlockLink"
      @select-section="onClickSectionBlockLink"
      @select-block="onClickAddressBlockLink"
    />
  </v-container>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import {
  required,
  max,
  length,
  alpha_dash,
  numeric,
  integer,
  max_value,
  min_value,
  regex,
} from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";
import AreaSelectorDialog from "@/components/address-selector/AreaSelectorDialog.vue";

import { useShopRegisterUiState } from "./composables/useShopRegisterUiState";
import { useShopRegisterForm } from "./composables/useShopRegisterForm";
import { useShopRegisterAddress } from "./composables/useShopRegisterAddress";
import { useShopRegisterApi } from "./composables/useShopRegisterApi";
import { useShopRegisterActions } from "./composables/useShopRegisterActions";
import { useShopRegisterInit } from "./composables/useShopRegisterInit";

// -----------------------------------------------------------------------------
// vee-validate rules
// -----------------------------------------------------------------------------
defineRule("required", required);
defineRule("max", max);
defineRule("length", length);
defineRule("alpha_dash", alpha_dash);
defineRule("numeric", numeric);
defineRule("integer", integer);
defineRule("max_value", max_value);
defineRule("min_value", min_value);
defineRule("regex", regex);
defineRule("ip_address", (value: string | null | undefined) => {
  if (value === null || value === undefined || value === "") return true;
  const ipv4Regex =
    /^((25[0-5]|2[0-4]\d|1?\d?\d)\.){3}(25[0-5]|2[0-4]\d|1?\d?\d)$/;
  return (
    ipv4Regex.test(value) ||
    "有効なIPv4アドレスを入力してください（例: 192.168.1.10）"
  );
});
defineRule("db_schema", (value: string | null | undefined) => {
  if (value === null || value === undefined || value === "") return true;
  const schemaRegex = /^[a-zA-Z_][a-zA-Z0-9_]{0,99}$/;
  return (
    schemaRegex.test(value) ||
    "英字またはアンダースコアで開始し、その後は英数字とアンダースコアのみ使用可能です（最大100文字）"
  );
});
// 2件分配数がチャーター数より大きいかどうかのバリデーション
defineRule(
  "lessThanCharter",
  (value: string | number | null | undefined, params: unknown) => {
    const {
      charter_deli_oricon_count,
      double_deli_oricon_count_label,
      charter_deli_oricon_count_label,
    } = params as {
      charter_deli_oricon_count: number | string;
      double_deli_oricon_count_label: string;
      charter_deli_oricon_count_label: string;
    };

    const val = Number(value);
    const charter = Number(charter_deli_oricon_count);

    if (!val || !charter || val < charter) return true;

    return `${double_deli_oricon_count_label}は${charter_deli_oricon_count_label}より小さい数字を入力してください。`;
  },
);
// 配送依頼受付通知先メールアドレスのバリデーション
defineRule("multipleEmail", (value: string) => {
  const mails = value.split(","); // カンマ区切りでメールアドレスを分割
  const regex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // メールアドレスの正規表現

  for (let i = 0; i < mails.length; i++) {
    if (!mails[i].match(regex)) {
      return "形式が不正なメールアドレスが含まれています。入力例を確認してください。";
    }
  }
  return true;
});

configure({
  generateMessage: localize({
    ja,
  }),
});
setLocale("ja");

// -----------------------------------------------------------------------------
// Composables
// -----------------------------------------------------------------------------

// UI状態
const {
  overlay,
  errdialog,
  errMessage,
  updateMode,
  dssFlg,
  displayConfirmDialog,
  displayCompletedDialog,
  areaDialog,
  validateOnMount,
  errdialogRefSetter,
} = useShopRegisterUiState();

// フォーム状態
const {
  shopCreateInput,
  getShopCountCountInput,
  formRef,
  chainListItems,
  chainSelectValues,
  chainViewFlag,
  ensureChainCode,
  dssListItems,
  dssSelectValues,
  dss_shop_name,
  deliverableItems,
  defaultDeliverable,
  deliverableSelectValues,
  isDeliverableNumberDisplay,
  useReceiptBarcodeSearch,
  shippingLabelPrintItems,
  shippingLabelPrintSelectValues,
  deliveryOrderPrintItems,
  deliveryOrderPrintSelectValues,
  tmpMemberRegistrationItems,
  tmpMemberRegistrationSelectValues,
  holidayItems,
  holidaySelectValues,
  wordList,
  deliveryRequestwordList,
  isWordListReady,
  doubleDeliOriconCountHintMessage,
  charterDeliOriconCountHintMessage,
  createShopMutation,
  listEditFlag,
  syncFormValues,
  allClear,
  onChangeDeliverable,
  updateModeSetHoliday,
  updateModeSetDelivarable,
} = useShopRegisterForm();

// 住所・郵便番号検索
const {
  errorZipCode,
  errorMessage,
  clickedBlockAddress,
  blockListFlg,
  prefValue,
  cityValue,
  sectionValue,
  zipAddressList,
  cityBlockList,
  sectionBlockList,
  blockList,
  onZipCodeInput,
  onClickCityBlockLink,
  onClickSectionBlockLink,
  onClickAddressBlockLink,
} = useShopRegisterAddress({
  shopCreateInput,
  chainSelectValues,
  ensureChainCode,
  errdialogRefSetter,
  areaDialog,
});

/** エリア選択ダイアログで表示する選択中住所。 */
const selectedAddressLabel = computed(() => {
  return `${prefValue.value}${cityValue.value}${sectionValue.value}`;
});

/** ダイアログ渡し用に丁目候補を null 安全な配列へ正規化する。 */
const areaDialogBlockList = computed(() => {
  return blockList.value ?? [];
});

/** areaDialog の v-model 更新を反映する。 */
const onAreaDialogUpdate = (value: boolean): void => {
  areaDialog.value = value;
};

// API通信
const {
  getListDssConnectionSetting,
  onInputShopCd,
  onBlurShopCd,
  onBlurShopName,
  checkShopName,
  onBlurDssShopCd,
  onChangeDssConnectionId,
  createShop,
} = useShopRegisterApi({
  shopCreateInput,
  getShopCountCountInput,
  chainSelectValues,
  dssListItems,
  dssSelectValues,
  dss_shop_name,
  dssFlg,
  overlay,
  errdialogRefSetter,
  ensureChainCode,
  zipAddressList,
  shippingLabelPrintSelectValues,
  deliveryOrderPrintSelectValues,
  tmpMemberRegistrationSelectValues,
  isDeliverableNumberDisplay,
  updateMode,
  createShopMutation,
});

// ボタン操作・画面遷移
const {
  onClickBack,
  onChangeChain,
  onClickOpenConfirmDialog,
  onClickConfirmCancel,
  onClickConfirmEntry,
  onClickCompletedGoStart,
} = useShopRegisterActions({
  shopCreateInput,
  displayConfirmDialog,
  displayCompletedDialog,
  overlay,
  validateOnMount,
  clickedBlockAddress,
  blockListFlg,
  dssSelectValues,
  dssFlg,
  updateMode,
  errdialog,
  errMessage,
  errorMessage,
  isDeliverableNumberDisplay,
  deliverableSelectValues,
  defaultDeliverable,
  holidaySelectValues,
  shippingLabelPrintSelectValues,
  shippingLabelPrintItems,
  deliveryOrderPrintSelectValues,
  deliveryOrderPrintItems,
  tmpMemberRegistrationSelectValues,
  tmpMemberRegistrationItems,
  chainSelectValues,
  chainViewFlag,
  dssListItems,
  dss_shop_name,
  createShopMutation,
  wordList,
  onBlurDssShopCd,
  getListDssConnectionSetting,
  checkShopName,
  createShop,
  allClear,
});

// 初期化（onMounted / watch）
useShopRegisterInit({
  shopCreateInput,
  wordList,
  deliveryRequestwordList,
  chainListItems,
  chainSelectValues,
  chainViewFlag,
  useReceiptBarcodeSearch,
  updateMode,
  dssFlg,
  clickedBlockAddress,
  shippingLabelPrintSelectValues,
  shippingLabelPrintItems,
  deliveryOrderPrintSelectValues,
  deliveryOrderPrintItems,
  tmpMemberRegistrationSelectValues,
  tmpMemberRegistrationItems,
  dssSelectValues,
  dssListItems,
  deliverableSelectValues,
  holidaySelectValues,
  formRef,
  isWordListReady,
  onChangeDeliverable,
  getListDssConnectionSetting,
  onBlurDssShopCd,
  updateModeSetHoliday,
  updateModeSetDelivarable,
  syncFormValues,
  allClear,
  listEditFlag,
  displayConfirmDialog,
});
</script>
<style scoped></style>
